export default __webpack_public_path__ + "static/calll-b3efb5f220136a9cdab93a1f90f10f3d.gif";